import React, { FC, useCallback, useState } from 'react';

import ReactCardFlip from 'react-card-flip';

import { RotateIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import {
  CarCardWrapper,
  CardColStyled,
  CardFrontBodyWrapper,
  CardFrontHeaderWrapper,
  CardFrontWrapper,
  FlipButton,
  LeftColWrapperStyled,
} from './CarRentalCard.styled';
import InfoDetail from './components/InfoDetail';
import InfoList from './components/InfoList';
import PriceInfo from './components/PriceInfo';
import CarCarousel from './components/CarCarousel';
import VehicleSpecifications from './components/VehicleSpecifications';
import { CarRentalCardPropTypes } from './CarRentalCardProps';

const CarCard: FC<CarRentalCardPropTypes> = ({
  className = '',
  vehicles = [],
  feature,
  condition,
  reservation,
  providerName,
  providerImageUrl,
  onCarSelect,
}) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleCardFlip = useCallback(
    () => setIsFlipped((oldIsFlipped) => !oldIsFlipped),
    []
  );

  const handleCarSelect = useCallback(() => onCarSelect(), [onCarSelect]);

  return (
    <CarCardWrapper>
      <ReactCardFlip
        isFlipped={isFlipped}
        containerClassName='carCard__flipContainer'
      >
        <CardFrontWrapper>
          <CardColStyled flex={3}>
            <CardFrontHeaderWrapper>
              <InfoDetail
                type={className ?? ''}
                modelName={vehicles[0]?.name ?? ''}
                alternativeModelName={
                  activeIndex === 0 ? '' : vehicles[activeIndex].name ?? ''
                }
                vehicleCount={vehicles.length ?? 0}
                activeIndex={activeIndex}
              />
              <FlipButton onClick={handleCardFlip}>
                <CustomIcon icon={RotateIcon} fontSize={11} />
                Tüm Özellikler/Kiralama Şartları
              </FlipButton>
            </CardFrontHeaderWrapper>
            <LeftColWrapperStyled>
              {isFlipped ? null : (
                <CarCarousel
                  vehicles={vehicles || []}
                  handleCarouselChange={setActiveIndex}
                  activeIndex={activeIndex}
                />
              )}
              <InfoList
                features={feature}
                conditions={condition}
                reservation={reservation}
                providerName={providerName ?? ''}
                providerImageUrl={providerImageUrl ?? ''}
              />
            </LeftColWrapperStyled>
          </CardColStyled>
          <CardColStyled hasBorderLeft flex={1}>
            <PriceInfo
              dayCount={reservation?.dayCount}
              milePrice={reservation?.price?.discountedMilePrice}
              price={reservation?.price?.price}
              totalPrice={reservation?.price?.discountedPrice}
              oneWayFee={reservation?.price?.oneWayFee}
              onCarSelect={handleCarSelect}
            />
          </CardColStyled>
        </CardFrontWrapper>
        <CardFrontWrapper>
          <CardColStyled flex={3}>
            <CardFrontHeaderWrapper hasBorderBottom>
              <InfoDetail
                type={className ?? ''}
                modelName={vehicles[0]?.name ?? ''}
                alternativeModelName={
                  activeIndex === 0 ? '' : vehicles[activeIndex].name ?? ''
                }
                vehicleCount={vehicles.length ?? 0}
                activeIndex={activeIndex}
              />
              <FlipButton onClick={handleCardFlip}>
                <CustomIcon icon={RotateIcon} fontSize={11} />
                Geri Dön
              </FlipButton>
            </CardFrontHeaderWrapper>
            <CardFrontBodyWrapper>
              <VehicleSpecifications
                features={feature}
                conditions={condition}
                reservation={reservation}
              />
            </CardFrontBodyWrapper>
          </CardColStyled>
          <CardColStyled hasBorderLeft flex={1}>
            <PriceInfo
              dayCount={reservation?.dayCount}
              milePrice={reservation?.price?.discountedMilePrice}
              price={reservation?.price?.price}
              totalPrice={reservation?.price?.discountedPrice}
              oneWayFee={reservation?.price?.oneWayFee}
              onCarSelect={handleCarSelect}
            />
          </CardColStyled>
        </CardFrontWrapper>
      </ReactCardFlip>
    </CarCardWrapper>
  );
};

export default CarCard;
